module.exports = "<ngb-pagination [collectionSize]=\"totalItems\" [pageSize]=\"itemsPerPage\" [(page)]=\"page\" [maxSize]=\"7\" [rotate]=\"true\" (pageChange)=\"loadPage($event)\"></ngb-pagination>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/pagination/pagination.component.html
// module id = ./src/app/shared/components/pagination/pagination.component.html
// module chunks = main